module.exports = __webpack_public_path__ + "img/android_1@2x.926d0155.png";